import React, { useContext, useState, useRef, useEffect } from "react";
import { BsQuestionCircle } from "react-icons/bs";
import downalodImg from "../../../assest/images/download.svg";
import { DataContext } from "../../index";

export const AmountSection = () => {
  // let [quantity, setQuantity] = useState({
  //   quantityAmount: 1,
  //   quantityPages: 24,
  // });
  const [showButton, setShowButton] = useState(false);
  const [showButton2, setShowButton2] = useState(false);

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);

  const counterState = useContext(DataContext);
  let {
    amountValue,
    setQuantity,
    quantity,
    setTotalAmount,
    onOpenModal,
    onOpenSummeryModal,
    setInfoData,
    onOpenDataModal,
    onOpenTourModel,
    handleOpen,
  } = counterState;

  const handleClickOutside = (event) => {
    setTimeout(() => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowButton(false);
      }
      if (inputRef2.current && !inputRef2.current.contains(event.target)) {
        setShowButton2(false);
      }
    }, 100);
  };

  const onSubmitFunc = (e) => {
    e.preventDefault();
    console.log(quantity);
    setQuantity(quantity);
    setTotalAmount(quantity);
    document.addEventListener("mousedown", handleClickOutside);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onChangeFunc = (e) => {
    if (e.target.name == "quantityAmount") {
      console.log("Run");
      setQuantity({ ...quantity, [e.target.name]: e.target.value });
      setShowButton(true);
    }
    if (e.target.name == "quantityPages") {
      console.log("Run");
      setQuantity({ ...quantity, [e.target.name]: e.target.value });
      setShowButton2(true);
    }
  };

  //  if(selectValue.section1 != null){
  //   setAmountValue(amountValue + selectValue.section1);
  //  }
  return (
    <div className="w-[650px]">
      <div className="col-md-3 p-0">
        <div className="tak-tours">
          <a href="javascript:;" className="themeBtn" onClick={() => handleOpen("one")}>
            Take A Quick Tour
          </a>
        </div>
        <div className="cal-step-count">
          <h3>OPTIONS</h3>
          <form onSubmit={onSubmitFunc}>
            <div className="form-row flex gap-2 w-full justify-between items-center align-items-center ">
              <div className="col !text-xs">
                <label for="" className="!text-xs ">
                  Quantity <span>1 or 25 - 2,000</span>
                </label>
              </div>
              <div className="col w-40">
                <input
                  type="number"
                  ref={inputRef}
                  defaultValue={quantity.quantityAmount}
                  className="form-control px-2 w-full"
                  name="quantityAmount"
                  onFocus={onChangeFunc}
                  onChange={onChangeFunc}
                />
              </div>
              {showButton == true ? (
                <button className="themeBtn !w-20 !text-xs !rounded-sm !h-8">
                  Update
                </button>
              ) : (
                <div className="col">
                  <p className="!text-xs">Nex price breaks at 25</p>
                </div>
              )}
            </div>
            <div className="form-row flex gap-2 justify-between items-center align-items-center mt-2 ">
              <div className="col w-full">
                <label for="" className="!text-xs">
                  Page Count <span>24 - 840</span>
                </label>
              </div>
              <div className="col w-full">
                <input
                  type="number"
                  ref={inputRef2}
                  defaultValue={quantity.quantityPages}
                  name="quantityPages"
                  onFocus={onChangeFunc}
                  onChange={onChangeFunc}
                  className="form-control w-full px-2"
                  min={24}
                  max={840}
                />
              </div>
              {showButton2 == true ? (
                <button className="themeBtn !w-52 !text-xs !rounded-sm !h-8">
                  Update
                </button>
              ) : (
                ""
              )}
            </div>

            <div className="form-row flex gap-2 justify-between items-center align-items-center mt-2">
              <div className="col w-full">
                <label for="" className="flex items-center gap-1 !text-xs">
                  Production Time{" "}
                  <BsQuestionCircle
                    fontSize={"18px"}
                    className="text-[#c65300]"
                    onClick={() => onOpenDataModal("productionTime")}
                  />
                </label>
              </div>
              <div className="col w-full">
                <div className="form-group">
                  <select
                    className="form-control !w-full"
                    id="exampleFormControlSelect1"
                  >
                    <option>Standard - 2 Days</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="cal-step-count noMargin">
          {/* <h3>
            PROJECT TYPE{" "}
            <span>
              <a href="javascript:;">Get a new quote</a>
            </span>
          </h3>
          <p>Printed Books</p> */}

          <h3>
            GENRE{" "}
            <span>
              <a href="javascript:;">See all trim sizes</a>
            </span>
          </h3>
          <p>Sci-Fi, Fantasy, & Comic Books</p>
        </div>

        <div className="cal-step-count noMargin !border-b-0">
          <h3>
            QUOTE{" "}
            <span onClick={onOpenSummeryModal}>
              <a href="javascript:;">View summary</a>
            </span>
          </h3>
          <form>
            <div className="form-row flex justify-between !my-4 align-items-center ">
              <div className="col">
                <label for="" className="label-icon">
                  Est. Ship Date{" "}
                  <span>
                    {/* <i className="fas fa-question"></i> */}
                    <BsQuestionCircle
                      fontSize={"18px"}
                      className="text-[#c65300]"
                      onClick={() => onOpenDataModal("estimateDate")}
                    />
                  </span>
                </label>
              </div>
              <div className="col">
                <h5>Tuesday, Feb 27</h5>
              </div>
            </div>

            <div className="form-row align-items-center flex justify-between">
              <div className="col">
                <label for="" className="label-icon">
                  Price
                  <br />{" "}
                  <span>
                    <BsQuestionCircle
                      fontSize={"18px"}
                      className="text-[#c65300]"
                      onClick={() => onOpenDataModal("price")}
                    />
                  </span>
                </label>
                <label for="" className="label-icon">
                  <span className="py-2">(Excludes Tax & Shipping)</span>
                </label>
              </div>
              <div className="col">
                <h6>${amountValue}.00</h6>
              </div>
            </div>

            <div className="form-row align-items-center mt-4 ">
              <div className="col">
                <a href="javascript:;" className="payBtn text-center">
                  Pay in 4 interest-free payments of $24.75 with
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
